import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from '../../../navigation/navigation';
import { UserService } from '../../../service/auth/user.service';
import { Router } from '@angular/router';

import { PusherService } from 'app/service/api/exame/notificacao.service';
import { ExameService } from 'app/service/api/exame/exame.service';

@Component({
    selector   : 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    user: any;
    somenteUmLocal: boolean;
    qtdPrioridadeDisponivel: number = 0;

    // Private
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private userSvc: UserService,
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private router: Router,
        private push : PusherService,
        private exameSvc: ExameService
    )
    {
        
        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'pt-br',
                title: 'Português',
                flag : 'pt-br'
            }

        ];

        this.navigation = navigation;

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this._unsubscribeAll = new Subject();
        
        var usr = this.userSvc.getUser();
        
        if(usr != null)
        {
         
         this.userSvc.onEstabelecimentoChanged
         .pipe( takeUntil(this._unsubscribeAll) )
         .subscribe( () =>  this.user = this.userSvc.getUser() );
        

         this.userSvc.onLogoff
         .pipe( takeUntil(this._unsubscribeAll) )
         .subscribe(() =>  this.router.navigate(['pages/auth/login']) );
    
            this.exameSvc.obterPrioridades()
            .subscribe(res=> this.qtdPrioridadeDisponivel = res.QtdDisponivel );

        this.push.OnPrioridadeChanged()
            .pipe( takeUntil(this._unsubscribeAll) )
            .subscribe(v=> this.qtdPrioridadeDisponivel = (<any>v).QuantidadeDisponivel );
        }
        
        this.user =  usr || { nome: '', estabelecimento: '' };

        // Subscribe to the config changes
        this._fuseConfigService.config
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((settings) => {
            this.horizontalNavbar = settings.layout.navbar.position === 'top';
            this.rightNavbar = settings.layout.navbar.position === 'right';
            this.hiddenNavbar = settings.layout.navbar.hidden === true;
        });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {'id': this._translateService.currentLang});
    }

    

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    { this._fuseSidebarService.getSidebar(key).toggleOpen(); }
    
    setLanguage(lang): void
    {
        this.selectedLanguage = lang;
        this._translateService.use(lang.id);
    }

    logout():void
    { this.userSvc.logoff(); }
}
